import { KontentDropdown } from "@components/global/Dropdown";
import { KontentLink } from "@components/global/FooterLink";
import { KontentButton } from "@components/ui/Button";
import { useStaticQuery, graphql } from "gatsby";

const useNavigationData = () => {
  const { kontentItemNavigation }: MobileNavigationData =
    useStaticQuery(graphql`
      query MobileNavigation {
        kontentItemNavigation(system: { name: { eq: "Mobile Navigation" } }) {
          elements {
            logo {
              value {
                width
                height
                description
                url
              }
            }
            main_links {
              value {
                system {
                  type
                }
                ... on kontent_item_dropdown {
                  elements {
                    title {
                      value
                    }
                    links {
                      value {
                        ... on kontent_item_link {
                          elements {
                            text {
                              value
                            }
                            open_in_new_window {
                              value {
                                codename
                              }
                            }
                            internal_path {
                              value
                            }
                            external_url {
                              value
                            }
                          }
                        }
                      }
                    }
                  }
                }
                ... on kontent_item_link {
                  elements {
                    text {
                      value
                    }
                    open_in_new_window {
                      value {
                        codename
                      }
                    }
                    internal_path {
                      value
                    }
                    external_url {
                      value
                    }
                  }
                  system {
                    type
                  }
                }
              }
            }
            secondary_links {
              value {
                system {
                  type
                }
                ... on kontent_item_link {
                  elements {
                    text {
                      value
                    }
                    open_in_new_window {
                      value {
                        codename
                      }
                    }
                    internal_path {
                      value
                    }
                    external_url {
                      value
                    }
                    icon {
                      value {
                        url
                        height
                        width
                      }
                    }
                  }
                  system {
                    type
                  }
                }
                ... on kontent_item_button {
                  elements {
                    internal_path {
                      value
                    }
                    external_url {
                      value
                    }
                    open_in_new_window {
                      value {
                        codename
                      }
                    }
                    text {
                      value
                    }
                    variant {
                      value {
                        codename
                      }
                    }
                  }
                  system {
                    type
                  }
                }
              }
            }
          }
        }
      }
    `);
  return kontentItemNavigation.elements;
};

export default useNavigationData;

// Type for an image
interface Image {
  width: number | null;
  height: number | null;
  description: string | null;
  url: string;
}

// Type for the main navigation links (can be either a link or a dropdown)
type MainLink = KontentLink | KontentDropdown;

// Type for the secondary navigation links (can be either a link or a button)
type SecondaryLink = KontentLink | KontentButton;

// Type for the overall navigation data structure
export interface MobileNavigationData {
  kontentItemNavigation: {
    elements: {
      logo: { value: Image[] };
      main_links: { value: MainLink[] };
      secondary_links: { value: SecondaryLink[] };
    };
  };
}
